import { render, staticRenderFns } from "./InsurenceInformation.vue?vue&type=template&id=6f1b1426&scoped=true"
import script from "./InsurenceInformation.vue?vue&type=script&lang=js"
export * from "./InsurenceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1b1426",
  null
  
)

export default component.exports